import { render, staticRenderFns } from "./SimulasiGadai.vue?vue&type=template&id=547a837c&scoped=true&"
import script from "./SimulasiGadai.vue?vue&type=script&lang=js&"
export * from "./SimulasiGadai.vue?vue&type=script&lang=js&"
import style0 from "./SimulasiGadai.vue?vue&type=style&index=0&id=547a837c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547a837c",
  null
  
)

export default component.exports